import React, { useEffect } from 'react'
import TheHeader from '../../container/TheHeader';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { PagoConID } from './PagoConID';
import { PagoSinID } from './PagoSinID';
import { withStepProgress } from 'react-stepz';
import { useDispatch, useSelector } from 'react-redux';
import { startCheckingToken } from 'src/reducer/action/auth';
import { Article } from 'src/common/LoadingContentCommon';
// import { setItemStepz } from 'src/helpers/localstorage';

// import TheFooter from '../../container/TheFooter';
// import { loadPolizasByIdentificacion } from 'src/reducer/action/poliza';
import { isMobile, isTablet, isBrowser } from 'react-device-detect';

export const Pago = withStepProgress(() => {

  const dispatch = useDispatch();
  const { token, idacceso } = useParams();

  const { loadingUiPago } = useSelector(state => state.ui);
  const { identificacion, checkingIdentificacion } = useSelector(state => state.auth);


  useEffect(() => {
    dispatch(startCheckingToken(token, idacceso));
  }, [token, idacceso])

  let tipoDispositivo = 'UNKNOWN';

  if (isTablet) {
    tipoDispositivo = 'TABLET';
  } else if (isMobile) {
    tipoDispositivo = 'MOBILE';
  } else if (isBrowser) {
    tipoDispositivo = 'DESKTOP';
  }


  return (
    <React.Fragment>
      <TheHeader />
      <div id='pago'>
        <Container>
          {
            !loadingUiPago
              ? (
                checkingIdentificacion && (
                  <div className='form-row justify-content-center'>
                    {
                      !identificacion
                        ? (
                          <PagoSinID />
                        )
                        : (
                          <PagoConID
                            identificacion={identificacion}
                          />
                        )
                    }
                  </div>
                )

              )
              : (
                <Article />
              )
          }
        </Container>
      </div>
      {/* <TheFooter /> */}
    </React.Fragment>
  )
})
